<div class="passenger-accordion">
  <form [formGroup]="group">
    <div class="passenger-accordion__heading">
      <div class="heading__passenger-info">
        <div class="font-weight-bold passenger-info__passenger-name">
          {{ passenger.genderType | genderPrefix | translate }} {{ passenger.firstName }} {{ passenger.lastName }}
        </div>
        <span class="ml-2">{{ passenger.dateOfBirth }}</span>
        <ng-container *ngIf="!passenger.nameChangeAvailable && (nameChangeInfo$ | async) as info">
          <span
            *ngIf="info.body"
            class="cursor-pointer"
            containerClass="popover-primary"
            popoverClass="popover-fixed-bottom"
            [placement]="'bottom'"
            [adaptivePosition]="true"
            triggers="hover"
            [popover]="popoverTemplate"
          >
            <i class="passenger-change-alert__icon mdi mdi-information pr-3"></i>
          </span>
          <ng-template #popoverTemplate>
            <div [innerHTML]="info.body"></div>
          </ng-template>
        </ng-container>
        <span class="ml-4" *ngIf="passenger.frequentFlyer"
          >{{ 'PASSENGER_CHANGE.FREQUENT_FLYER' | translate }}{{ passenger.frequentFlyer }}</span
        >
      </div>

      <div class="mb-2 custom-control custom-checkbox align-self-center">
        <input
          (change)="onSwitchChange($event)"
          type="checkbox"
          id="edit-{{ index }}"
          class="custom-control-input"
          [disabled]="!isEnabled()"
        />
        <label class="custom-control-label font-weight-normal font-weight-bold-hover cursor-pointer" for="edit-{{ index }}">{{
          'PASSENGER_CHANGE.CHANGE_DETAILS' | translate
        }}</label>
      </div>
    </div>
    <div class="passenger-accordion__content" *ngIf="isOpen">
      <div class="passenger-details__gender-change">
        <span class="font-weight-bold">{{ 'PASSENGER_CHANGE.PASSENGER_DETAILS.GENDER' | translate }}</span>
        {{ 'PASSENGER_CHANGE.PASSENGER_DETAILS.AS_IN_PASSPORT' | translate }}
        <div class="gender-change__options">
          <div *ngFor="let gender of genders; let i = index" class="custom-control custom-radio">
            <input
              type="radio"
              class="custom-control-input"
              [id]="'gender' + index + '-' + i"
              formControlName="genderSelector"
              [value]="gender"
            />
            <label class="custom-control-label" [for]="'gender' + index + '-' + i">
              {{ gender | genderPipe | translate }}
            </label>
          </div>
        </div>
      </div>
      <div class="passenger-details__name-change">
        <div class="name-change__first-name">
          <label [for]="'first-name' + index"
            ><span class="font-weight-bold">{{ 'PASSENGER_CHANGE.PASSENGER_DETAILS.FIRST_NAME' | translate }}</span>
            {{ 'PASSENGER_CHANGE.PASSENGER_DETAILS.AS_IN_PASSPORT' | translate }}
          </label>
          <input type="text" [id]="'first-name' + index" formControlName="firstName" class="form-control" [value]="passenger.firstName" />
        </div>
        <div class="name-change__last-name">
          <label [for]="'last-name' + index"
            ><span class="font-weight-bold">{{ 'PASSENGER_CHANGE.PASSENGER_DETAILS.LAST_NAME' | translate }}</span>
            {{ 'PASSENGER_CHANGE.PASSENGER_DETAILS.AS_IN_PASSPORT' | translate }}
          </label>
          <input type="text" [id]="'last-name' + index" formControlName="lastName" class="form-control" [value]="passenger.lastName" />
        </div>
      </div>
      <div class="passenger-details__birthdate-change">
        <div class="name-change__birthdate">
          <label [for]="'birthdate' + index"
            ><span class="font-weight-bold">{{ 'PASSENGER_CHANGE.PASSENGER_DETAILS.DATE_OF_BIRTH' | translate }}</span>
          </label>
          <input
            type="text"
            [id]="'birthdate' + index"
            formControlName="dateOfBirth"
            class="form-control"
            [value]="passenger.dateOfBirth"
          />
        </div>
      </div>
    </div>
  </form>
</div>
